import { LocalStorageService } from './../local-storage.service';
import { Injectable, inject } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { ApiResponse } from './../../../core/models/response-api';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class StatService extends CrudService<ApiResponse<any>, number> {
  _localStorageService = inject(LocalStorageService);
  type: any;

  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
    this.type = this._localStorageService.getData('userConnected')!;
  }
  getStat(esn_id: any) {
    if (this.type == 2) {
      return this._http.get<ApiResponse<any>>(
        `${this._base}/api/Statistic/getStatisticByEsn?esn_id=${esn_id}`
      );
    } else {
      return this._http.get<ApiResponse<any>>(
        `${this._base}/api/Statistic/getStatisticByClient?client_id=${esn_id}`
      );
    }
  }
  getStatESN() {
      return this._http.get<ApiResponse<any>>(
        `${this._base}/api/Statistic/getStatisticByEsn`
      );
  }
}
